module.exports = __webpack_public_path__ + "static/media/icon_user_01.b41e4a42.svg";